import { withWithoutApplicationSettings } from "lib/settings";
import { Onboarding } from "ui/layouts/Dashboard";
import { Protected } from "ui/layouts/Auth";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { withLoadingBackdropOverlay } from "ui/layouts/LoadingBackdropOverlay";

const Component = (props: ScreenProps) => (
    <Protected>
        <Screen
            {...props}
            title='E-Commerce | Onboarding'
        >
            <Onboarding />
        </Screen>
    </Protected>
);

export default withLoadingBackdropOverlay(withWithoutApplicationSettings(Component));
